/* eslint-disable no-case-declarations */
// src/components/VoucherTable/getVoucherColumns.tsx

import { Badge, Flex, Text, Image, Tooltip, Box } from '@chakra-ui/react';

import { createColumnHelper } from '@tanstack/react-table';

import { MerchantField } from 'app/constants/table';

import { Merchant } from '@aslanpay/portal-common-lib';
import { CheckIcon, CloseIcon } from '@chakra-ui/icons';
import appEnv from 'app/config/appEnv';

const S3_BUCKET_URI = appEnv.VITE_S3_BUCKET_URI as string;

export function getMerchantsColumns() {
  const columnHelper = createColumnHelper<Merchant>();

  return Object.keys(MerchantField).map((field) => {
    return columnHelper.accessor(field as keyof Merchant, {
      header: MerchantField[field as keyof typeof MerchantField],
      cell: (info) => {
        switch (field as keyof typeof MerchantField) {
          case 'description':
            return <Text>{info.getValue() as string}</Text>;
          case 'name':
            return (
              <Text color="brand.purple" textStyle="extraSmallMedium">
                {info.getValue() as string}
              </Text>
            );
          case 'logoUrl':
            const logoPath = info.getValue() as string | undefined;
            const fullLogoUrl = S3_BUCKET_URI + logoPath;
            return logoPath ? (
              <Image boxSize="40px" src={fullLogoUrl} objectFit="contain" alt={logoPath} />
            ) : (
              <Text>No logo</Text>
            );
          case 'isPopular': {
            const isPopular = info.getValue() as boolean;
            return (
              <Badge colorScheme={isPopular ? 'green' : 'red'} px="2" py="1" borderRadius="md">
                <Flex align="center" justify="center">
                  {isPopular ? <CheckIcon boxSize={4} /> : <CloseIcon boxSize={4} />}
                </Flex>
              </Badge>
            );
          }
          case 'url':
            return (
              <Tooltip label={info.getValue() as string} placement="top">
                <Box maxW="250px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
                  <Text
                    as="a"
                    href={info.getValue() as string}
                    target="_blank"
                    rel="noopener noreferrer"
                    color="blue.500"
                  >
                    {info.getValue() as string}
                  </Text>
                </Box>
              </Tooltip>
            );
          default:
            return info.getValue();
        }
      },
      enableSorting: false,
      meta: {
        ...(field === 'description' && {
          customStyles: {
            maxWidth: '100%',
            overflowWrap: 'break-word',
            whiteSpace: 'normal',
            width: 'auto',
          },
        }),
        ...(field === 'logoUrl' && { customStyles: { justifyContent: 'center' } }),
        ...(field === 'isPopular' && { customStyles: { justifyContent: 'center' } }),
      },
    });
  });
}

export default getMerchantsColumns;
